import { render, staticRenderFns } from "./T1MapaSerwisuContent.vue?vue&type=template&id=c95c5b4c&scoped=true&"
import script from "./T1MapaSerwisuContent.vue?vue&type=script&lang=js&"
export * from "./T1MapaSerwisuContent.vue?vue&type=script&lang=js&"
import style0 from "./T1MapaSerwisuContent.vue?vue&type=style&index=0&id=c95c5b4c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c95c5b4c",
  null
  
)

export default component.exports